import { CookieRemoveIcon } from './CookieRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 25272102-387C-4333-BF16-3308E6EFF94F
 * name cookie-remove
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-remove.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitRemoveIcon = CookieRemoveIcon;
export default BiscuitRemoveIcon